import './EventsFilter.scss';
import template from './EventsFilter.vhtml';
import EventBus from '../eventBus';

export default {
	name: 'EventsFilter',
	template: template,
	props: {
		types: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		activeType: '',
		eventTypes: null,
	}),
	computed: {},
	methods: {
		selectType(slug) {
			const newUrl =
				window.location.href.replace(window.location.search, '') +
				'?eventtype=' +
				slug;
			window.history.pushState('', '', newUrl);
			EventBus.$emit('type-changed', slug);
			this.activeType = slug;
		},
		getActiveClass(slug) {
			return this.activeType === slug ? 'events-filter__btn--active' : '';
		},
	},
	mounted() {
		this.eventTypes = JSON.parse(this.types);
		this.activeType = window.location.search.replace('?eventtype=', '');
	},
};
